export default "__VITE_ASSET__BBrrsjXy__"